const component = {
  common404: {
    path: 'common/404',
    title: '404'
  },
  message: {
    path: 'common/Message',
    title: 'Message'
  },
  loading: {
    path: 'common/Loading',
    title: 'Loading'
  },
  login: {
    path: 'common/Login',
    title: 'Login'
  }
};

export default {
  name: 'common',
  component
};
